import { BiDataWidgetPlacement } from '@wix/wix-help-widget/types';
import * as util from '#packages/util';
import type { Shell } from '#packages/apilib';
import { EditorAPIKey } from '#packages/apis';
import {
  startNewWorkspaceLeftBarHighlightTour,
  StartOrigin,
  startWelcomeTour,
} from '#packages/editorTours';

export function createHelpWidgetApi(shell: Shell) {
  const editorAPI = shell.getAPI(EditorAPIKey);

  return {
    startWelcomeTour: async () => {
      return util.workspace.isNewWorkspaceFTETourEnabled()
        ? startNewWorkspaceLeftBarHighlightTour(editorAPI, StartOrigin.HelpMenu)
        : startWelcomeTour(editorAPI, StartOrigin.HelpMenu);
    },
    openHelpArticle: (articleId: string) => {
      window.WixSupportChatSDK?.openHelpWidgetArticle({
        articleId,
        centerPosition: true,
        biData: {
          // for now `openHelpArticle` api is used only from GFPP
          // in case it is called from other place it should be updated
          placement: BiDataWidgetPlacement.GFPP,
        },
      });
    },
    openHelpWidgetSearch: (query: string) => {
      window.WixSupportChatSDK?.openHelpWidgetSearch({ query });
    },
  };
}
